
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"9","height":"28"}},[_c('path',{attrs:{"d":"M9 14a.99.99 0 01-.297.703l-7 7A.996.996 0 011 22c-.547 0-1-.453-1-1V7c0-.547.453-1 1-1a.99.99 0 01.703.297l7 7A.996.996 0 019 14z"}})])
      }
    
      }
    